export * from "./SvgIcon";
